/**
 * Toggle Switch UI Component
 *
 * @example <toggle-switch
 *              model="vm.model"
 *              left-val="vm.leftVal"
 *              right-val="vm.rightVal"
 *              left-label="{{vm.leftLabel"
 *              right-label="{{vm.rightLabel}}">
 *           </toggle-switch>
 * @description Deprecated in favour of sc-toggle-switch. Inserts a toggle switch UI component.
 * @namespace Core
 * @memberof TR
 */

'use strict';

namespace Core {

    class ToggleSwitch implements ng.IDirective {
        prefix: string;
        restrict = 'E';
        replace = true;
        transclude = true;
        scope = {
            model : '=',
            leftVal : '=',
            rightVal : '=',
            leftLabel : '@',
            rightLabel : '@'
        };
        templateUrl = 'partials/home/directivetemplate?type=ToggleSwitch';

        constructor() {

        }

        link = (scope: ng.IScope) => {

            scope.class = function() {
                return scope.model === scope.rightVal ? 'on' : '';
            };

            scope.toggle = function() {
                scope.model = (scope.model === scope.leftVal ? scope.rightVal : scope.leftVal);
            };
        }

        static factory(): ng.IDirectiveFactory {
            const directive = () => new ToggleSwitch();
            directive.$inject = [];
            return directive;
        }
    }

    const TR = angular.module('TR');
    TR.directive('toggleSwitch', ToggleSwitch.factory());

}
